import {useLayoutEffect} from 'react';

/**
 * react-aria patches HTMLTemplateElement.prototype.firstChild to return
 * content.firstChild (@react-aria/collections Hidden.mjs, working around
 * facebook/react#19932 for SSR hydration). We never server-render, and the patch
 * makes React's caret walk in commitBeforeMutationEffects descend into the
 * template's DocumentFragment and then climb out through a null parentNode --
 * an uncatchable mid-commit crash whenever a RAC collection renders inside a
 * focused contentEditable (i.e. Slate, i.e. reports).
 *
 * Deleted on every render rather than once at startup: the patch reinstalls
 * whenever a lazily-loaded chunk evaluates another copy of the package.
 * appendChild/removeChild/insertBefore stay patched -- React still writes the
 * hidden tree into content, the caret walk just sees an empty <template>.
 */
export function useUnpatchTemplateFirstChild(): void {
  useLayoutEffect(() => {
    if (Object.hasOwn(HTMLTemplateElement.prototype, 'firstChild')) {
      delete (HTMLTemplateElement.prototype as any).firstChild;
    }
  });
}
